import { useState } from "react";

export const FuelLegend = () => {
  const [isOpen, setIsOpen] = useState(false);

  const fuelTypes = [
    { 
      code: "PHEV (híbrid endollable)",
      description: "És un cotxe que combina motor elèctric i motor de gasolina/dièsel. Es pot endollar per carregar la bateria i fer trajectes curts només amb electricitat."
    },
    { 
      code: "MHEV (híbrid lleuger)",
      description: "No es pot endollar. Porta un petit motor elèctric que ajuda el motor principal a arrencar i accelerar, reduint consum i emissions."
    },
    { 
      code: "Híbrid (convencional)",
      description: "Té motor elèctric i de combustió. No s'endolla: la bateria es carrega sola quan frena o circula."
    },
    { 
      code: "Gasolina MHEV",
      description: "Motor de gasolina amb ajuda d'un sistema elèctric petit que fa el cotxe una mica més eficient."
    },
    { 
      code: "Dièsel MHEV",
      description: "Motor dièsel amb suport elèctric lleu per consumir menys i contaminar menys."
    },
    { 
      code: "Gasolina",
      description: "Cotxe tradicional que només funciona amb gasolina."
    },
    { 
      code: "Dièsel",
      description: "Cotxe tradicional que només funciona amb gasoil."
    },
    { 
      code: "Elèctric",
      description: "Cotxe que només funciona amb electricitat, s'endolla i no fa emissions quan circula."
    },
  ];

  return (
    <div className="mb-6">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
        Llegenda de combustibles
      </button>

      {isOpen && (
        <div className="mt-4 p-5 bg-secondary rounded-xl border border-border">
          <div className="space-y-4">
            {fuelTypes.map((fuel) => (
              <div key={fuel.code}>
                <div className="font-bold text-sm text-foreground mb-1">
                  {fuel.code}
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {fuel.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

